<template>
  <div class="audience-assest-page" v-if="allData.length > 0">
    <div class="title">受众评估</div>
    <el-alert v-if="estimateStatus === 1" class="alert" title="预估覆盖日活量较少" :closable="false" type="warning" show-icon> </el-alert>
    <el-table class="asset-table" empty-text="请选择广告位后，查看受众预估" :data="tableData" size="mini" style="width: 100%">
      <el-table-column prop="mediaName" label="广告位">
        <template slot-scope="scope">
          <img style="width: 20px; position: relative; top: 5px; margin-right: 6px" :src="getImgUrl(scope.row.name)" />
          <span>{{ scope.row.mediaName }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="convertNum">
        <template slot="header">
          覆盖数(人)
          <el-tooltip class="item" effect="dark" content="根据广告位日活用量计算得出，小于1万时显示预估覆盖日活量较少" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="title">已选定向</div>
    <div class="detail" v-if="regions && regions.length > 0"><span class="detail-title">地域：</span>{{ regions.join("，") }}</div>
    <div class="detail" v-if="targetData.gender !== 'GENDER_UNLIMITED'">
      <span class="detail-title">性别：</span>{{ targetData.gender === "GENDER_MALE" ? "男" : "女" }}
    </div>
    <div class="detail" v-if="targetData.age && targetData.age.length > 0">
      <span class="detail-title">年龄：</span>{{ ageName.join("，") }}
    </div>
    <div class="detail" v-if="targetData.ac && targetData.ac.length > 0">
      <span class="detail-title">网络：</span>{{ targetData.ac.join("，") }}
    </div>
    <div class="detail"><span class="detail-title">平台：</span>{{ targetData.platform }}</div>
    <div class="detail" v-if="targetData.platform === 'ANDROID'">
      <span class="detail-title">安卓版本：</span>
      {{ (android_osv_list.find((item) => item.value === targetData.android_osv) || {}).label }}
    </div>
    <div class="detail" v-if="targetData.platform === 'IOS'">
      <span class="detail-title">IOS版本：</span>
      {{ (ios_osv_list.find((item) => item.value === targetData.ios_osv) || {}).label }}
    </div>
    <div v-if="targetData.interest_action_mode === 'CUSTOM'">
      <div class="detail"><span class="detail-title">行为场景：</span>{{ actionSceneName.join("，") }}</div>
      <div class="detail"><span class="detail-title">行为天数：</span>{{ targetData.action_days }}天</div>
    </div>
    <div class="detail" v-if="targetData.device_type && targetData.device_type.length > 0">
      <span class="detail-title">设备类型：</span>{{ deviceTypeName.join("，") }}
    </div>
    <div class="detail" v-if="targetData.hide_if_exists !== '0'">
      <span class="detail-title">已安装用户：</span>{{ targetData.hide_if_exists === "1" ? "过滤" : "定向" }}
    </div>
    <div class="detail">
      <span class="detail-title">过滤已转化用户：</span>
      {{ (hide_if_converted_type_list.find((item) => item.value === targetData.hide_if_converted) || {}).label }}
    </div>
    <div class="detail" v-if="targetData.hide_if_converted === 'APP' && (!deliveryRange || deliveryRange.delivery_range !== 'UNION')">
      <span class="detail-title">过滤时间：</span>
      {{ (filter_time_type_list.find((item) => item.value === targetData.filter_time) || {}).label }}
    </div>
    <div class="detail" v-if="targetData.carrier && targetData.carrier.length > 0">
      <span class="detail-title">运营商：</span>{{ carrierName.join("，") }}
    </div>
    <div class="detail" v-if="targetData.activate_type && targetData.activate_type.length > 0">
      <span class="detail-title">新用户：</span>{{ activateName.join("，") }}
    </div>
    <div class="detail" v-if="targetData.platform === 'ANDROID' && targetData.device_brand && targetData.device_brand.length > 0">
      <span class="detail-title">手机品牌：</span>
      {{ deviceBrandName.join("，") }}
    </div>
    <div class="detail" v-if="targetData.launch_price && targetData.launch_price.length > 1">
      <span class="detail-title">手机价格：</span>{{ targetData.launch_price[0] }}元 -{{ targetData.launch_price[1] }}元
    </div>
    <div
      class="detail"
      v-if="(!deliveryRange || deliveryRange.delivery_range !== 'UNION') && targetData.career && targetData.career.length > 0"
    >
      <span class="detail-title">职业状态：</span>
      {{ careerName.join("，") }}
    </div>
    <div
      class="detail"
      v-if="targetData.auto_extend_enabled === 1 && targetData.auto_extend_targets && targetData.auto_extend_targets.length > 0"
    >
      <span class="detail-title">智能扩量：</span>
      {{ extendTargetsName.join("，") }}
    </div>
    <div class="detail" v-if="targetData.targeting_name">
      <span class="detail-title">定向包名称：</span>
      {{ targetData.targeting_name }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "lodash";
import { getEstimateAudience, getPackParams, getCrowdTag } from "@/api/promotion";
import { careerTypeList } from "./subDirectpkg/dybehaviorList.js";
import optionList from "./subDirectpkg/optionData.js";
import {
  more_age_type_list,
  age_type_list,
  action_scene_type_list,
  device_type_list,
  hide_if_converted_type_list,
  filter_time_type_list,
  carrier_type_list,
  activate_type_list,
  auto_extend_targets_type_list,
  inventory_type_list,
} from "./subDirectpkg/optionData";
export default {
  name: "page-name",

  components: {},

  data() {
    return {
      age_type_list,
      more_age_type_list,
      action_scene_type_list,
      device_type_list,
      hide_if_converted_type_list,
      filter_time_type_list,
      carrier_type_list,
      activate_type_list,
      careerTypeList,
      auto_extend_targets_type_list,
      android_osv_list: optionList.android_osv_list,
      ios_osv_list: optionList.ios_osv_list,
      inventory_type_list,
      tableData: [],
      allData: [],
      regions: [],
      targetData: {},
      brandList: [],
      estimateStatus: "",
    };
  },

  computed: {
    ...mapState({
      currentSelectedAudience: (state) => state.PromotionTtV2.currentSelectedAudience,
      currentSelectedTargeting: (state) => state.PromotionTtV2.currentSelectedTargeting,
      audience: (state) => state.PromotionTtV2.audiences,
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
      deliveryRange: (state) => state.PromotionTtV2.deliveryRange,
    }),
    ageName() {
      let name = [];
      const { age, moreAgeMode } = this.targetData;
      age?.map((item) => {
        const list = moreAgeMode ? this.more_age_type_list : this.age_type_list;
        const findObj = list.find((child) => child.value === item);
        name.push(findObj.label);
      });
      return name;
    },
    actionSceneName() {
      let name = [];
      this.targetData.action_scene?.map((item) => {
        const findObj = this.action_scene_type_list.find((child) => child.value === item);
        name.push(findObj.label);
      });
      return name;
    },
    deviceTypeName() {
      let name = [];
      this.targetData.device_type?.map((item) => {
        const findObj = this.device_type_list.find((child) => child.value === item);
        name.push(findObj.label);
      });
      return name;
    },
    carrierName() {
      let name = [];
      this.targetData.device_brand?.map((item) => {
        const findObj = this.carrier_type_list.find((child) => child.value === item);
        name.push(findObj.label);
      });
      return name;
    },
    activateName() {
      let name = [];
      this.targetData.activate_type?.map((item) => {
        const findObj = this.activate_type_list.find((child) => child.value === item);
        name.push(findObj.label);
      });
      return name;
    },
    deviceBrandName() {
      let name = [];
      this.targetData.device_brand?.map((item) => {
        const findObj = this.brandList.find((child) => child.key === item);
        name.push(findObj.label);
      });
      return name;
    },
    careerName() {
      let name = [];
      this.targetData.career?.map((item) => {
        const findObj = this.careerTypeList.find((child) => child.key === item);
        name.push(findObj.label);
      });
      return name;
    },
    extendTargetsName() {
      let name = [];
      this.targetData.auto_extend_targets?.map((item) => {
        const findObj = this.auto_extend_targets_type_list.find((child) => child.value === item);
        name.push(findObj.label);
      });
      return name;
    },
    showPlaceTypeList() {
      let typeList = [];
      const { delivery_range, inventory_catalog, inventory_type } = this.deliveryRange || {};
      if (delivery_range === "UNION") {
        typeList = [];
      } else if (delivery_range === "UNIVERSAL") {
        typeList = ["tomato_novel_app", "aweme", "video_app", "toutiao"];
      } else {
        if (inventory_catalog === "UNIVERSAL_SMART") {
          typeList = ["tomato_novel_app", "aweme", "video_app", "toutiao"];
        } else {
          typeList = [];
          inventory_type?.map((item) => {
            typeList.push(inventory_type_list.find((child) => child.value === item).icon);
          });
        }
      }
      return typeList;
    },
  },

  watch: {
    currentSelectedTargeting: {
      handler(val) {
        this.targetData = val;
        if (val && this.adCount) {
          this.getData(this);
        }
      },
      deep: true,
      // immediate: true,
    },
    "currentSelectedAudience.data": {
      handler(val) {
        if (val) {
          this.getData(this);
        }
      },
      deep: true,
      // immediate: true,
    },
    deliveryRange() {
      this.getData(this);
    },
  },

  mounted() {
    getPackParams({
      platType: 1,
    }).then((res) => {
      this.brandList = Object.entries(res.device_brand)?.map((item) => ({
        key: item[0],
        label: item[1],
      }));
    });
  },

  methods: {
    getData: debounce(async (that) => {
      let currentData = {};
      if (that.currentSelectedAudience) {
        currentData = that.currentSelectedAudience?.data;
      } else {
        if (that.audience?.length > 0) {
          await getCrowdTag({ advertiserId: that.adCount }).then((res) => {
            currentData = {
              retargeting_tags_exclude: [],
              retargeting_tags_include: [],
            };
            that.audience[0].retargeting_tags_exclude.map((item) => {
              const findObj = res.crowdTags.find((child) => child.custom_audience_id == item);
              currentData.retargeting_tags_exclude.push(findObj);
            });
            that.audience[0].retargeting_tags_include.map((item) => {
              const findObj = res.crowdTags.find((child) => child.custom_audience_id == item);
              currentData.retargeting_tags_include.push(findObj);
            });
          });
        }
      }
      getEstimateAudience({
        advertiserId: that.adCount,
        targeting: that.currentSelectedTargeting,
        audience: currentData,
      }).then((res) => {
        that.tableData = [];
        that.allData = res.data?.estimateAudienceList;
        res.data?.estimateAudienceList?.map((item) => {
          if (that.showPlaceTypeList.includes(item.name)) {
            that.tableData.push(item);
          }
        });
        that.regions = res.data?.regions;
        that.estimateStatus = res.data.estimateStatus;
      });
    }, 500),
    getImgUrl(src) {
      return require(`./static/${src}.png`);
    },
  },
};
</script>

<style lang="less" scoped>
.audience-assest-page {
  width: 100%;
  flex: 1;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  padding: 16px 24px;
  box-sizing: border-box;
  margin-top: 12px;
  overflow: auto;
  .title {
    font-weight: 600;
    font-size: 16px;
    color: #000;
  }
  .alert {
    margin: 12px 0;
  }
  .asset-table {
    margin-bottom: 20px;
    margin-top: 12px;
    /deep/ th {
      height: 30px;
    }
    /deep/ .el-table__cell {
      padding: 2px 0;
    }
  }
  .detail {
    font-size: 13px;
    line-height: 20px;
    color: #999;
    margin-top: 6px;
    .detail-title {
      color: #000;
    }
  }
}
</style>
